import FloatingInputWrapper from "shared/components/layouts/FloatingInputWrapper";
import React, { useRef, useState } from "react";

const PhoneInput = ({
  onChange,
}: {
  onChange: (value: string, type: "phone" | "areacode") => void;
}) => {
  const [phoneValue, setPhoneValue] = useState<string>("");
  const [areaCodeValue, setAreaCodeValue] = useState<string>("+44");
  const areaCodeInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);

  const handlePhoneChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^\d{0,15}$/;
    if (regex.test(e.target.value)) {
      setPhoneValue(e.target.value);
      onChange(phoneValue, "phone");
      e.preventDefault();
    }
  };

  const handleAreaPhoneChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^\+(\d{1,4})?$/;
    if (regex.test(e.target.value)) {
      setAreaCodeValue(e.target.value);
      onChange(areaCodeValue, "areacode");
      e.preventDefault();
    }
  };

  const handlePhoneInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (!phoneValue && e.code === "Backspace") {
      if (areaCodeInputRef.current) {
        areaCodeInputRef.current.focus(); // Focus the input
      }
    }
  };

  const handleAreaPhoneInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (areaCodeValue.length === 5 && e.code !== "Backspace") {
      if (phoneInputRef.current) {
        phoneInputRef.current.focus(); // Focus the input
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        border: "1px solid rgb(194, 199, 209)",
        paddingRight: "0px",
        borderRadius: "4px",
      }}
    >
      <FloatingInputWrapper
        id="areacode"
        placeholder="Phone"
        shrink={areaCodeValue ? true : false}
        styleProps={{ paddingRight: "0px" }}
      >
        <input
          required={true}
          size={areaCodeValue.length < 3 ? 3 : areaCodeValue.length || 3}
          value={areaCodeValue}
          onChange={handleAreaPhoneChanged}
          onKeyDown={handleAreaPhoneInputKeyDown}
          type="tel"
          pattern="^\+(\d{1,4})$"
          ref={areaCodeInputRef}
        />
      </FloatingInputWrapper>
      <FloatingInputWrapper
        id="phone"
        placeholder=""
        shrink={phoneValue ? true : false}
        styleProps={{ flexGrow: 1, paddingLeft: "0px" }}
      >
        <input
          required={true}
          style={{ flexGrow: "1" }}
          type="tel"
          onChange={handlePhoneChanged}
          onKeyDown={handlePhoneInputKeyDown}
          value={phoneValue}
          pattern="^\d{4,15}$"
          ref={phoneInputRef}
        />
      </FloatingInputWrapper>
    </div>
  );
};

export default PhoneInput;